import { ActiveProjectComponent } from './projects/active-project/active-project.component';
import { allIcons } from 'angular-feather/icons';
import { AnalaticsStatComponent } from './analytics/analatics-stat/analatics-stat.component';
import { BestSellingComponent } from './dashboard/best-selling/best-selling.component';
import { ClosingDealsComponent } from './crm/closing-deals/closing-deals.component';
import { CommonModule } from '@angular/common';
import { CountUpModule } from 'ngx-countup';
import { CrmStatComponent } from './crm/crm-stat/crm-stat.component';
import { CryptoStatComponent } from './crypto/crypto-stat/crypto-stat.component';
import { CurrenciesComponent } from './crypto/currencies/currencies.component';
import { DealsStatusComponent } from './crm/deals-status/deals-status.component';
import { FeatherModule } from 'angular-feather';
import { FormsModalModule } from 'src/app/forms-modal/forms-modal.module';
import { MyTaskComponent } from './projects/my-task/my-task.component';
import { NftStatComponent } from './nft/nft-stat/nft-stat.component';
import { NewsFeedComponent } from './crypto/news-feed/news-feed.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbDropdownModule, NgbProgressbarModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { ProjectsStatComponent } from './projects/projects-stat/projects-stat.component';
import { RecentOrdersComponent } from './dashboard/recent-orders/recent-orders.component';
import { RouterModule } from '@angular/router';
import { StatComponent } from './dashboard/stat/stat.component';
import { TeamMembersComponent } from './projects/team-members/team-members.component';
import { TopPagesComponent } from './analytics/top-pages/top-pages.component';
import { TopPerformersComponent } from './crypto/top-performers/top-performers.component';
import { TopSellingComponent } from './dashboard/top-selling/top-selling.component';
import { UpcomingActivitiesComponent } from './crm/upcoming-activities/upcoming-activities.component';
import { UsersMostCostComponent } from './dashboard/users-most-cost/users-most-cost.component';

@NgModule({
  declarations: [
    ActiveProjectComponent,
    AnalaticsStatComponent,
    BestSellingComponent,
    ClosingDealsComponent,
    CrmStatComponent,
    CryptoStatComponent,
    CurrenciesComponent,
    DealsStatusComponent,
    MyTaskComponent,
    NewsFeedComponent,
    NftStatComponent,
    ProjectsStatComponent,
    RecentOrdersComponent,
    StatComponent,
    TeamMembersComponent,
    TopPagesComponent,
    TopPerformersComponent,
    TopSellingComponent,
    UpcomingActivitiesComponent,
    UsersMostCostComponent
  ],
  imports: [
    CommonModule,
    CountUpModule,
    FeatherModule.pick(allIcons),
    FormsModalModule,
    NgApexchartsModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    NgbTooltipModule,
    RouterModule
  ],
  exports: [
    ActiveProjectComponent,
    AnalaticsStatComponent,
    BestSellingComponent,
    ClosingDealsComponent,
    CrmStatComponent,
    CryptoStatComponent,
    CurrenciesComponent,
    DealsStatusComponent,
    MyTaskComponent,
    NewsFeedComponent,
    NftStatComponent,
    ProjectsStatComponent,
    RecentOrdersComponent,
    StatComponent,
    TeamMembersComponent,
    TopPagesComponent,
    TopPerformersComponent,
    TopSellingComponent,
    UpcomingActivitiesComponent,
    UsersMostCostComponent
  ]
})

export class WidgetModule { }
